document.addEventListener('DOMContentLoaded', function () {
  // Инициализируем Ripple-эффект для всех кнопок
  document.querySelectorAll('.mdc-button, .mdc-icon-button, .mdc-card__primary-action').forEach(function (rippleEl) {
    mdc.ripple.MDCRipple.attachTo(rippleEl);
  });

  // --- Выдвижная панель (Drawer) ---
  var drawerEl = document.querySelector('.mdc-drawer');
  if (drawerEl) {
    var drawer = mdc.drawer.MDCDrawer.attachTo(drawerEl);

    // Инициализируем Top App Bar только если есть Drawer
    var topAppBarElement = document.querySelector('.mdc-top-app-bar');
    if (topAppBarElement) {
      var topAppBar = mdc.topAppBar.MDCTopAppBar.attachTo(topAppBarElement);
      topAppBar.setScrollTarget(document.querySelector('.main-content'));
      topAppBar.listen('MDCTopAppBar:nav', function () {
        drawer.open = !drawer.open;
      });
    }
  }

  // --- Модальные окна ---

  // 1. Модальное окно с политикой
  var privacyDialogEl = document.querySelector('#privacy-dialog');
  if (privacyDialogEl) {
    var privacyDialog = mdc.dialog.MDCDialog.attachTo(privacyDialogEl);
    // Находим ВСЕ кнопки/ссылки для открытия окна с политикой по классу
    var openPrivacyDialogButtons = document.querySelectorAll('.open-privacy-dialog');
    
    openPrivacyDialogButtons.forEach(function(button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        // Устанавливаем z-index выше, чем у других модальных окон
        privacyDialogEl.style.zIndex = '10'; 
        privacyDialog.open();
      });
    });

    // Добавляем обработчик для ссылки в окне про cookie
    var openPrivacyDialogButtonCookies = document.querySelector('#open-privacy-dialog-cookies');
    if (openPrivacyDialogButtonCookies) {
      openPrivacyDialogButtonCookies.addEventListener('click', function (event) {
        event.preventDefault();
        // То же самое для ссылки из cookie-баннера
        privacyDialogEl.style.zIndex = '10';
        privacyDialog.open();
      });
    }
  }

  // 2. Модальное окно с уведомлением о cookie
  var cookiesDialogEl = document.querySelector('#cookies-dialog');
  if (cookiesDialogEl && !localStorage.getItem('cookiesAccepted')) {
    var cookiesDialog = mdc.dialog.MDCDialog.attachTo(cookiesDialogEl);
    cookiesDialog.open();
    cookiesDialog.listen('MDCDialog:closed', function (event) {
      if (event.detail.action === 'accept') {
        localStorage.setItem('cookiesAccepted', 'true');
      }
    });
  }

  // 3. Модальное окно "Стать партнером"
  var partnerDialogEl = document.querySelector('#partner-dialog');
  if (partnerDialogEl) {
    var partnerDialog = mdc.dialog.MDCDialog.attachTo(partnerDialogEl);
    var openPartnerDialogButton = document.querySelector('#open-partner-dialog');
    if (openPartnerDialogButton) {
      openPartnerDialogButton.addEventListener('click', function () {
        partnerDialog.open();
      });
    }
  }

  // --- Галерея и выбор цвета на странице товара ---
  var gallery = document.getElementById('product-gallery');
  if (gallery) {
    var mainImage = document.getElementById('main-product-image');
    var thumbnailContainer = document.getElementById('thumbnail-container');
    var colorSwatches = document.querySelectorAll('.color-swatch');
    var selectedColorInput = document.getElementById('selected-color-input');
    var productNameInput = document.getElementById('product-name-input');
    var productTitle = document.querySelector('.product-info__title');

    // Заполняем скрытое поле с названием товара
    if (productNameInput && productTitle) {
      productNameInput.value = productTitle.textContent.trim();
    }

    // Функция для обновления миниатюр
    var updateThumbnails = function updateThumbnails(imageUrls) {
      thumbnailContainer.innerHTML = ''; // Очищаем контейнер
      imageUrls.forEach(function (url, index) {
        var thumb = document.createElement('img');
        thumb.src = url;
        thumb.dataset.src = url;
        thumb.alt = 'Миниатюра '.concat(index + 1);
        thumb.className = 'product-gallery__thumbnail';
        if (index === 0) {
          thumb.classList.add('active');
        }
        thumbnailContainer.appendChild(thumb);
      });
      // Переназначаем обработчики кликов на новые миниатюры
      setupThumbnailClicks();
    };

    // Функция для назначения кликов на миниатюры
    var setupThumbnailClicks = function setupThumbnailClicks() {
      var thumbnails = thumbnailContainer.querySelectorAll('.product-gallery__thumbnail');
      thumbnails.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          mainImage.src = this.dataset.src;
          thumbnails.forEach(function (t) {
            return t.classList.remove('active');
          });
          this.classList.add('active');
        });
      });
    };

    // Обработчики для кнопок выбора цвета
    colorSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        // Обновляем активный класс у кнопок
        colorSwatches.forEach(function (s) {
          return s.classList.remove('active');
        });
        this.classList.add('active');

        // Обновляем значение скрытого поля в форме
        var selectedColor = this.dataset.color;
        if (selectedColorInput) {
          selectedColorInput.value = selectedColor;
        }

        var images = JSON.parse(this.dataset.images);
        if (images && images.length > 0) {
          mainImage.src = images[0]; // Устанавливаем первое изображение как основное
          updateThumbnails(images); // Обновляем миниатюры
        }
      });
    });

    // Инициализация при загрузке страницы
    setupThumbnailClicks();
    // Устанавливаем начальные миниатюры для активного цвета
    var initialSwatch = document.querySelector('.color-swatch.active');
    if (initialSwatch) {
      updateThumbnails(JSON.parse(initialSwatch.dataset.images));
    }
  }

  // --- Логика "Просмотренные товары" ---
  var VIEWED_PRODUCTS_KEY = 'viewedProducts';
  var MAX_VIEWED_PRODUCTS = 4;
  var productDetailContainer = document.querySelector('[data-product-id]');
  var viewedProductsSection = document.getElementById('viewed-products-section');

  // 1. Если мы на странице товара, сохраняем его
  if (productDetailContainer) {
    var product = {
      id: productDetailContainer.dataset.productId,
      name: document.querySelector('.product-info__title').textContent,
      price: document.querySelector('.product-info__price').textContent,
      image: document.querySelector('.product-main-image').src,
      url: productDetailContainer.dataset.productUrl
    };

    var viewed = JSON.parse(localStorage.getItem(VIEWED_PRODUCTS_KEY)) || [];

    // Удаляем товар, если он уже есть, чтобы переместить его в начало
    viewed = viewed.filter(function (p) {
      return p.id !== product.id;
    });

    // Добавляем текущий товар в начало списка
    viewed.unshift(product);

    // Ограничиваем количество товаров
    if (viewed.length > MAX_VIEWED_PRODUCTS) {
      viewed.pop();
    }

    localStorage.setItem(VIEWED_PRODUCTS_KEY, JSON.stringify(viewed));
  }

  // 2. Если на странице есть блок для просмотренных товаров, отображаем их
  if (viewedProductsSection) {
    var _viewed = JSON.parse(localStorage.getItem(VIEWED_PRODUCTS_KEY)) || [];
    var currentProductId = productDetailContainer ? productDetailContainer.dataset.productId : null;

    // Фильтруем, чтобы не показывать текущий товар в списке просмотренных
    var productsToDisplay = _viewed.filter(function (p) {
      return p.id !== currentProductId;
    });

    if (productsToDisplay.length > 0) {
      var grid = document.getElementById('viewed-products-grid');
      grid.innerHTML = ''; // Очищаем контейнер

      productsToDisplay.forEach(function (product) {
        var productHtml = "\n          <div class=\"mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone\">\n            <a href=\"".concat(product.url, "\" class=\"mdc-card product-card\">\n              <div class=\"mdc-card__primary-action\" tabindex=\"0\">\n                <div class=\"mdc-card__media mdc-card__media--square product-card__media\" style=\"background-image: url('").concat(product.image, "')\"></div>\n                <div class=\"product-card__primary\">\n                  <h3 class=\"product-card__title mdc-typography--subtitle1\">").concat(product.name, "</h3>\n                  <p class=\"product-card__price\">").concat(product.price, "</p>\n                </div>\n              </div>\n            </a>\n          </div>\n        ");
        grid.insertAdjacentHTML('beforeend', productHtml);
      });

      // Инициализируем ripple-эффекты для новых карточек
      grid.querySelectorAll('.mdc-card__primary-action').forEach(function (rippleEl) {
        mdc.ripple.MDCRipple.attachTo(rippleEl);
      });

      viewedProductsSection.style.display = 'block'; // Показываем блок
    }
  }

  // --- Карусель "Наша продукция" ---
  var carousel = document.getElementById('product-carousel');
  if (carousel) {
    new Splide(carousel, {
      type: 'loop',
      // Бесконечная прокрутка
      perPage: 4,
      // По 4 слайда на десктопе
      perMove: 1,
      gap: '1rem',
      // Отступ между слайдами
      autoplay: true,
      // Включаем автопрокрутку
      interval: 2000,
      // Интервал в миллисекундах (4 секунды)
      pagination: false,
      // Отключаем точки-пагинацию
      breakpoints: {
        1024: {
          perPage: 3 // 3 на планшете
        },

        768: {
          perPage: 3 // 2 на мобильных
        },

        599: {
          perPage: 2 // 1 на маленьких мобильных
        }
      }
    }).mount();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('price-search-input');
  if (!searchInput) {
    return; // Если на странице нет поиска, ничего не делаем
  }

  const priceTables = document.querySelectorAll('.price-table');
  if (priceTables.length === 0) {
    return; // Если на странице нет таблиц с ценами, выходим
  }

  const resultsCountEl = document.getElementById('search-results-count');

  searchInput.addEventListener('input', function (e) {
    const searchTerm = e.target.value.toLowerCase().trim();
    let totalFound = 0;

    priceTables.forEach(table => {
      const rows = table.querySelectorAll('tbody tr');
      rows.forEach(row => {
        const rowText = row.textContent.toLowerCase();
        const isVisible = rowText.includes(searchTerm);
        row.style.display = isVisible ? '' : 'none';
        if (isVisible) {
          totalFound++;
        }
      });
    });

    // Обновляем счетчик результатов
    if (searchTerm && resultsCountEl) {
      resultsCountEl.textContent = `Найдено позиций: ${totalFound}`;
      resultsCountEl.style.display = 'block';
    } else if (resultsCountEl) {
      resultsCountEl.style.display = 'none';
    }
  });
});

$(document).on('af_complete', function(event, response) {
    // Проверяем, что событие пришло от нашей формы
    if (response.form.attr('id') === 'feedback-form') {
        // Если форма отправлена успешно (нет ошибок)
        if (response.success) {
            // AjaxForm сам сбрасывает форму, так что reset() не нужен.
            // Но если бы нужно было что-то сделать дополнительно,
            // мы бы сделали это здесь.
            console.log('Форма #feedback-form успешно отправлена!');
            
            // Например, можно показать кастомное модальное окно "Спасибо!"
            // const thankYouDialog = new mdc.dialog.MDCDialog(document.getElementById('thank-you-dialog'));
            // thankYouDialog.open();
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
  // Применяем маску для всех полей ввода с типом "tel"
  $('input[type="tel"]').mask('+7 (999) 999-99-99');
});

console.log('Material Components Initialized!');